import React, { useState, useEffect, useRef } from "react";
import api from "../../../../services/api";
import styles from "./CheckComponent.module.css";

import { useAuth } from '../../../Base/Auth/contexts/AuthContext';
// ...
import { useSocket } from '../../../../context/SocketContext';

const CheckComponent = ({ receiptId, onClose, onCheckIssued }) => {
  const [receiptData, setReceiptData] = useState(null);
  const [checkData, setCheckData] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState("cash");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [availableEmails, setAvailableEmails] = useState([]);
  const [availablePhones, setAvailablePhones] = useState([]);
  const [status, setStatus] = useState("Ожидание...");
  const [error, setError] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const isSendOptionsValid = Boolean(email.trim() || phone.trim());
  const [selectedContact, setSelectedContact] = useState(null);

  const [isManualEmail, setIsManualEmail] = useState(false);
  const [isManualPhone, setIsManualPhone] = useState(false);

  const isRefundCompleted = checkData?.refund_status === "completed";
  
  const socket = useSocket();
  // Обработчик для выбора контакта из списка
  const handleSelectContact = (type, value) => {
    setSelectedContact({ type, value });
    if (type === "email") {
      setEmail(value);
      setPhone(""); // сбросить телефон
    } else if (type === "phone") {
      setPhone(value);
      setEmail(""); // сбросить email
    }
  };

  useEffect(() => {
  if (!socket || !receiptId) return;

  // 1) подписываемся на канал
  socket.emit('check:subscribe', { receiptId }, err => {
    if (err) console.error('subscribe error', err);
    else console.log(`Subscribed to receipt ${receiptId}`);
  });

  // 2) слушаем обновления
  const onUpdate = (fullCheck) => {
    // fullCheck уже в формате JSON, если сервер отправляет .toJSON()
    console.log('Получен check:update', fullCheck);
    setCheckData(fullCheck);
    setStatus(fullCheck.status === 'completed'
      ? (fullCheck.refund_status === 'completed' ? 'Чек возвращён' : 'Чек пробит')
      : status
    );
    setIsProcessing(false);
    if (fullCheck.status === 'completed') {
      onCheckIssued(receiptId);  // ← здесь
      //onClose();                // ← и сразу закрываем модалку
    }
  };
  socket.on('check:update', onUpdate);

  // 3) при размонтировании — отписываемся
  return () => {
    socket.emit('check:unsubscribe', { receiptId }, err => {
      if (err) console.error('unsubscribe error', err);
      else console.log(`Unsubscribed from receipt ${receiptId}`);
    });
    socket.off('check:update', onUpdate);
  };
}, [socket, receiptId]);


  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setSelectedContact({ type: "email", value: e.target.value });
    setPhone(""); // очищаем телефон
  };
  
  const handlePhoneChange = (e) => {
    setPhone(e.target.value);
    setSelectedContact({ type: "phone", value: e.target.value });
    setEmail(""); // очищаем email
  };

  // Переключение на ручной ввод для email
  const handleManualEmail = () => {
    setIsManualEmail(true);
    setIsManualPhone(false); // Отключаем режим ввода телефона, если он был включен
    setSelectedContact({ type: "", value: "" }); // Сбрасываем выбранный контакт
    setEmail(""); // Сбрасываем значение, чтобы поле ввода было пустым
    setTimeout(() => {
      emailInputRef.current && emailInputRef.current.focus();
    }, 100);
  };

  // Переключение на ручной ввод для телефона
  const handleManualPhone = () => {
    setIsManualPhone(true);
    setIsManualEmail(false); // Отключаем режим ввода email, если он был включен
    setSelectedContact({ type: "", value: "" });
    setPhone(""); // Сбрасываем значение, чтобы поле ввода было пустым
    setTimeout(() => {
      phoneInputRef.current && phoneInputRef.current.focus();
    }, 100);
  };

  // Отмена ручного ввода для email
  const cancelManualEmail = () => {
    setIsManualEmail(false);
  };

  // Отмена ручного ввода для телефона
  const cancelManualPhone = () => {
    setIsManualPhone(false);
  };


  const emailInputRef = useRef(null);
  const phoneInputRef = useRef(null);




  const { user } = useAuth();

  const eventSourceRef = useRef(null);



  // Загружаем данные квитанции по receiptId
  useEffect(() => {
    const fetchReceiptDetails = async () => {
      try {
        console.log(`Запрашиваю квитанцию ${receiptId}...`);
        const response = await api.get(`/receipts/${receiptId}`);
        setReceiptData(response);
      } catch (err) {
        setError("Ошибка при получении данных квитанции");
        console.error(err);
      }
    };
    fetchReceiptDetails();
  }, [receiptId]);

// Вставить сразу после существующего useEffect с fetchReceiptDetails
useEffect(() => {
  (async () => {
    try {
      const resp = await api.get(`/check/${receiptId}/check/details`);
      setCheckData(resp);
    } catch (err) {
      if (err.response?.status !== 404) {
        console.error(err);
        setError("Ошибка при загрузке чека");
      }
      // 404 — значит чек ещё не пробит, оставляем пустым
    }
  })();
}, [receiptId]);
  const updateReceiptStatus = async (receiptId, status) => {
    try {
      console.log(`Обновляю статус квитанции ${receiptId} на ${status}...`);
      await api.patch(`/receipts/${receiptId}/status`, { status });
    } catch (err) {
      console.error("Ошибка при обновлении статуса квитанции:", err);
    }
  };

  // После загрузки квитанции заполняем поля по умолчанию
  useEffect(() => {
    if (receiptData) {
      if (!email) {
        setEmail(receiptData.email || "");
      }
      if (!phone && receiptData.delivery_comment) {
        const phoneRegex = /((?:8|\+7)[\s-]*(?:\(?\d{3}\)?)[\s-]*\d{3}[\s-]*\d{2}[\s-]*\d{2})/;
        const match = receiptData.delivery_comment.match(phoneRegex);
        const extractedPhone = match ? match[0].replace(/[\s\-()]/g, "") : "";
        setPhone(extractedPhone);
      }
    }
  }, [receiptData]);

  useEffect(() => {
    if (receiptData) {
      // Извлекаем email
      let emails = [];
      if (receiptData.email) emails.push(receiptData.email);
      if (receiptData.contract_comment) {
        emails = [...emails, ...extractEmails(receiptData.contract_comment)];
      }
      emails = [...new Set(emails)];
      setAvailableEmails(emails);
  
      // Извлекаем телефоны
      let phones = [];
      const phoneRegex = /((?:8|\+7)[\s-]*(?:\(?\d{3}\)?)[\s-]*\d{3}[\s-]*\d{2}[\s-]*\d{2})/g;
      if (receiptData.delivery_comment) {
        const matches = receiptData.delivery_comment.match(phoneRegex);
        if (matches) {
          phones = matches.map(phone => phone.replace(/[\s\-()]/g, ""));
        }
      }
      phones = [...new Set(phones)];
      setAvailablePhones(phones);
  
      // Если доступны email – выбираем первый, иначе если есть телефон – выбираем его
      if (emails.length > 0) {
        setEmail(emails[0]);
        setSelectedContact({ type: "email", value: emails[0] });
      } else if (phones.length > 0) {
        setPhone(phones[0]);
        setSelectedContact({ type: "phone", value: phones[0] });
      }
    }
  }, [receiptData]);
  

  const extractEmails = (text) => {
    if (!text) return [];
    const emailRegex = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g;
    return text.match(emailRegex) || [];
  };

  const handlePaperCheckRequest = async () => {
    try {
      await api.patch(`/receipts/${receiptId}/status`, { reason: "Хотят бумажный чек" });
      alert("Запрос на бумажный чек отправлен.");
    } catch (err) {
      console.error("Ошибка при отправке запроса на бумажный чек:", err);
      alert("Ошибка при отправке запроса.");
    }
  };

  const handleRefund = async () => {
    if (!receiptId) return;
  
    const confirmed = window.confirm("Вы уверены, что хотите сделать возврат по этой квитанции?");
    if (!confirmed) return;
  
    setIsProcessing(true);
    setStatus("Инициализация возврата...");
  
    try {
      const response = await api.post(`/check/${receiptId}/refund`);
      setStatus("Возврат успешно выполнен");
  
      // обновляем чековые данные
      const updatedCheck = await api.get(`/check/${receiptId}/check/details`);
      setCheckData(updatedCheck);
    } catch (err) {
      const serverError = err.response?.data?.message || err.message;
      setError("Ошибка при выполнении возврата: " + serverError);
      setStatus("Ошибка при возврате");
      console.error(err);
    } finally {
      setTimeout(() => setIsProcessing(false), 3000);
    }
  };
  

  const handleIssueCheck3 = async () => {
    if (!receiptData) {
      setError("Квитанция не загружена");
      console.error("❌ Квитанция не загружена");
      return;
    }
    setIsProcessing(true);
    setStatus("Инициализация запроса...");

    try {
      // Формируем payload для выбития чека
      const payload = {
        receipt: {
          id: receiptData.id,
          receipt_number: receiptData.receipt_number,
          delivery_address: receiptData.delivery_address,
          client_name: receiptData.client_name,
          email: receiptData.email,
          payment_type: receiptData.payment_type,
          amount: parseFloat(receiptData.amount),
          to_pay: parseFloat(receiptData.to_pay),
          paid: parseFloat(receiptData.paid),
          products: receiptData.products.map((product) => ({
            product_number: product.product_number,
            product_name: product.product_name,
            actual_quantity: product.actual_quantity,
            price: parseFloat(product.price),
            actual_tare_sale_quantity: parseFloat(product.actual_tare_sale_quantity),
            tare_price: parseFloat(product.tare_price),
            is_marked: product.is_marked,
            marks: product.marks || [],
          })),
        },
        paymentMethod, // "cash" или "card"
        sendOptions: {
          email: email.trim() || receiptData.email || null,
          phone: phone.trim() || null,
        },
      };

      console.log(
        "📤 Отправка данных для нового чека:",
        JSON.stringify(payload, null, 2)
      );

      // Отправляем данные на сервер (эндпоинт можно изменить при необходимости)
      await api.post(`/receipts/${receiptId}/issue-check`, payload);

      // Обновляем данные чека
      const updatedCheck = await api.get(`/check/${receiptId}/check/details`);
      setCheckData(updatedCheck);
      setStatus("Чек зарегистрирован в ATOL, ожидаем callback...");
    } catch (err) {
      setError("Ошибка при отправке чека");
      console.error("Ошибка при отправке чека:", err);
    } finally {
      // 🔵 Держим кнопку неактивной ещё 5 секунд после завершения операции
      setTimeout(() => {
        setIsProcessing(false);
      }, 5000);
    }
  };

  const handleIssueCheck = async () => {
    if (!receiptData) {
      setError("Квитанция не загружена");
      console.error("❌ Квитанция не загружена");
      return;
    }
    setIsProcessing(true);
    setStatus("Инициализация запроса...");

    try {
      // Формируем payload для выбития чека
      const payload = {
        paymentMethod, // "cash" или "card"
        sendOptions: {
          email: email.trim() || receiptData.email || null,
          phone: phone.trim() || null,
        },
      };

      console.log(
        "📤 Отправка данных для нового чека:",
        JSON.stringify(payload, null, 2)
      );

      // Отправляем данные на сервер (эндпоинт можно изменить при необходимости)
      await api.post(`/check/${receiptId}/issue-check`, payload);

      // Обновляем данные чека
      
      setStatus("Чек зарегистрирован в ATOL, ожидаем callback...");
    } catch (err) {
      const serverError = err.response && err.response.data ? err.response.data : err.message;
      setError(typeof serverError === 'object' ? JSON.stringify(serverError) : serverError);

      console.error("Ошибка при отправке чека:", serverError);
    }
  };

  const handleSetCheckErrorStatus = async () => {
    try {
      await api.patch(`/receipts/${receiptId}/check/error`);
      setStatus("Статус чека установлен в 'Ошибка'");
      alert("Статус установлен в 'Ошибка'");
    } catch (err) {
      console.error("Ошибка при установке статуса 'Ошибка':", err);
      alert("Не удалось установить статус.");
    }
  };

  
  

  const manuallyCloseReceipt = async () => {
    try {
      await updateReceiptStatus(receiptId, "Закрыта");
      setStatus("Статус квитанции изменён на 'Закрыта'");
    } catch (err) {
      setError("Ошибка при закрытии квитанции");
      console.error("Ошибка при закрытии квитанции:", err);
    }
  };

  // Функция копирования ссылки в буфер обмена
  const copyLink = (link) => {
    navigator.clipboard.writeText(link).then(() => {
      alert("Ссылка скопирована");
    });
  };

  // Если checkData существует и статус "completed" (или "done"), отображаем детали
  const isCheckCompleted = checkData && checkData.status === "completed";

  return (
    <div className={styles.checkPageContainer}>
      {error && (
        <p className={styles.errorText}>
          <strong>Ошибка:</strong> {error}
        </p>
      )}

      {isCheckCompleted ? (
        <div className={styles.checkDetails}>
          <h3 className={styles.checkStatus}>
            Статус чека: {isRefundCompleted ? "🔁 Чек возвращён" : status}
          </h3>

          <ul className={styles.detailsList}>
            <li><strong>Номер смены:</strong> {checkData.shift_number || "-"}</li>
            <li><strong>UUID:</strong> {checkData.atol_uuid || "-"}</li>
            <li><strong>Контакты покупателя:</strong> {email} / {phone}</li>
            <li>
              <strong>Товары с маркировкой:</strong>
              <ul className={styles.markedList}>
                {receiptData?.products?.map(prod => (
                  <li key={prod.product_number}>
                    {prod.product_name} – маркировка: {prod.marks?.length > 0 ? prod.marks.join(", ") : "нет"}
                  </li>
                ))}
              </ul>
            </li>
          </ul>

          <div className={styles.checkActions1}>
            {checkData.status === "completed" && checkData.check_link && (
              <>
                <button className={styles.mainButton} onClick={() => copyLink(checkData.check_link)}>
                  Скопировать ссылку
                </button>
                <button className={styles.mainButton} onClick={() => window.open(checkData.check_link, "_blank") }>
                  Посмотреть чек
                </button>
                <button className={styles.mainButton} onClick={handlePaperCheckRequest}>
                  Хотят бумажный чек
                </button>
                {!isRefundCompleted && (
                  <button className={styles.refundButton} onClick={handleRefund} disabled={isProcessing}>
                    Сделать возврат
                  </button>
                )}
              </>
            )}

            {isRefundCompleted && checkData.refund_link && (
              <>
                <button className={styles.mainButton} onClick={() => copyLink(checkData.refund_link)}>
                  Скопировать ссылку возврата
                </button>
                <button className={styles.mainButton} onClick={() => window.open(checkData.refund_link, "_blank") }>
                  Посмотреть возвратный чек
                </button>
              </>
            )}
          </div>
        </div>
      ) : (
        <div className={styles.checkForm1}>
          <h3>Настройка чека</h3>

          <div className={styles.checkModalInputGroup}>
            <label>Способ оплаты:</label>
            <div className={styles.paymentOptions}>
              {['cash','card'].map(method => (
                <div
                  key={method}
                  className={`${styles.paymentOption} ${paymentMethod===method?styles.selected:''}`}
                  onClick={()=>setPaymentMethod(method)}
                >{method==='cash'?'Наличные':'Карта'}</div>
              ))}
            </div>
          </div>

          <div className={styles.checkModalInputGroup}>
            <label>Email:</label>
            {isManualEmail ? (
              <div className={styles.contactInputWrapper}>
                <input
                  ref={emailInputRef}
                  type="email"
                  className={styles.contactOption}
                  value={email}
                  onChange={handleEmailChange}
                  placeholder="Введите email вручную"
                />
                <button className={styles.contactOption} onClick={cancelManualEmail}>
                  Отменить ввод
                </button>
              </div>
            ) : (
              <div className={styles.contactInputWrapper}>
                {availableEmails.map((em,i)=>(
                  <div key={i}
                       className={`${styles.contactOption} ${selectedContact?.type==='email'&&selectedContact.value===em?styles.selected:''}`}
                       onClick={()=>handleSelectContact('email',em)}>
                    {em}
                  </div>
                ))}
                <button className={styles.contactOption} onClick={handleManualEmail}>
                  Ввести email вручную
                </button>
              </div>
            )}
          </div>

          <div className={styles.checkModalInputGroup}>
            <label>Телефон:</label>
            {isManualPhone ? (
              <div className={styles.contactInputWrapper}>
                <input
                  ref={phoneInputRef}
                  type="text"
                  className={styles.contactOption}
                  value={phone}
                  onChange={handlePhoneChange}
                  placeholder="Введите телефон вручную"
                />
                <button className={styles.contactOption} onClick={cancelManualPhone}>
                  Отменить ввод
                </button>
              </div>
            ) : (
              <div className={styles.contactInputWrapper}>
                {availablePhones.map((ph,i)=>(
                  <div key={i}
                       className={`${styles.contactOption} ${selectedContact?.type==='phone'&&selectedContact.value===ph?styles.selected:''}`}
                       onClick={()=>handleSelectContact('phone',ph)}>
                    {ph}
                  </div>
                ))}
                <button className={styles.contactOption} onClick={handleManualPhone}>
                  Ввести телефон вручную
                </button>
              </div>
            )}
          </div>

          <div className={styles.inputGroup}>
            <button className={styles.issueCheckButton} onClick={handleIssueCheck} disabled={isProcessing}>
              {isProcessing?'Обработка...':'Пробить чек'}
            </button>
            <button className={styles.errorStatusButton} onClick={handleSetCheckErrorStatus} disabled={isProcessing}>
              Установить статус "Ошибка"
            </button>
          </div>

          <strong>Статус:</strong> {status}

          <div className={styles.inputGroup}>
            <button className={styles.closeReceiptButton} onClick={manuallyCloseReceipt} disabled={isProcessing}>
              Закрыть без чека
            </button>
          </div>

          <div className={styles.receiptSummary}>
            <span><i className="bi bi-hash"></i> {receiptData?.id}</span>
            <span><i className="bi bi-person-fill"></i> {receiptData?.client_name}</span>
            <span><i className="bi bi-receipt"></i> {receiptData?.receipt_number}</span>
          </div>

          <div className={styles.productsList}>
            {receiptData?.products?.map(p=>(
              <div key={p.id} className={styles.product}>
                <strong>{p.product_name}</strong>
                <div className={styles.productInfo}>
                  <i className="bi-droplet"></i> {p.actual_quantity}
                  <i className="bi bi-cash"></i> {p.price} ₽
                  {p.gtin==='04600840744001'&&(
                    <><i className="bi bi-bucket"></i> {p.actual_tare_sale_quantity||0}
                       <i className="bi bi-cash-coin"></i> {p.tare_price||0} ₽</>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CheckComponent;
